import axios from "axios";
import { parseAdditionalHeaders } from "../chatWidget/utils";

export async function sendMessage(baseUrl: string, flowId: string, message: string, input_type: string, output_type: string, sessionId: React.MutableRefObject<string>, output_component?: string, tweaks?: Object, api_key?: string, additional_headers?: { [key: string]: string } | string) {
    let data: any;
    data = { input_type, input_value: message, output_type }
    if (tweaks) {
        data["tweaks"] = tweaks
    }
    if (output_component) {
        data["output_component"] = output_component;
    }
    let headers: { [key: string]: string } = { "Content-Type": "application/json" }
    if (api_key) {
        headers["x-api-key"] = api_key;
    }
    if (additional_headers) {
        // Parse additional_headers if it's a string (can happen when passed as HTML attribute)
        const parsedHeaders = parseAdditionalHeaders(additional_headers);
        if (parsedHeaders) {
            // Merge headers, ensuring all values are strings
            Object.keys(parsedHeaders).forEach(key => {
                headers[key] = String(parsedHeaders[key]);
            });
        }
    }
    if (sessionId.current && sessionId.current !== "") {
        data.session_id = sessionId.current;
    }
    let response = axios.post(`${baseUrl}/api/v1/run/${flowId}`, data, { headers });
    return response;
}

export async function sendMessageStream(
    baseUrl: string,
    flowId: string,
    message: string,
    input_type: string,
    output_type: string,
    sessionId: React.MutableRefObject<string>,
    executionId: string,
    output_component?: string,
    tweaks?: Object,
    api_key?: string,
    additional_headers?: { [key: string]: string } | string,
    lastEventId?: string
) {
    let data: any = { input_type, input_value: message, output_type };
    if (tweaks) data["tweaks"] = tweaks;
    if (output_component) data["output_component"] = output_component;
    
    let headers: { [key: string]: string } = {
        "Content-Type": "application/json",
        "Accept": "text/event-stream"
    };
    if (api_key) headers["x-api-key"] = api_key;
    if (lastEventId) headers["Last-Event-ID"] = lastEventId;
    
    if (additional_headers) {
        const parsedHeaders = parseAdditionalHeaders(additional_headers);
        if (parsedHeaders) {
            Object.keys(parsedHeaders).forEach(key => {
                headers[key] = String(parsedHeaders[key]);
            });
        }
    }
    if (sessionId.current && sessionId.current !== "") {
        data.session_id = sessionId.current;
    }
    
    return fetch(`${baseUrl}/api/v1/run/${flowId}/stream?execution_id=${executionId}`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data)
    });
}

export async function fetchHistory(baseUrl: string, sessionId: string, api_key?: string, additional_headers?: { [key: string]: string } | string) {
    let headers: { [key: string]: string } = { "Content-Type": "application/json" }
    if (api_key) {
        headers["x-api-key"] = api_key;
    }
    if (additional_headers) {
        const parsedHeaders = parseAdditionalHeaders(additional_headers);
        if (parsedHeaders) {
            Object.keys(parsedHeaders).forEach(key => {
                headers[key] = String(parsedHeaders[key]);
            });
        }
    }
    let response = axios.get(`${baseUrl}/api/v1/innlive/public/session/${sessionId}/history`, { headers });
    return response;
}

export async function fetchSessionStatus(baseUrl: string, sessionId: string, api_key?: string, additional_headers?: { [key: string]: string } | string) {
    let headers: { [key: string]: string } = { "Content-Type": "application/json" }
    if (api_key) {
        headers["x-api-key"] = api_key;
    }
    if (additional_headers) {
        const parsedHeaders = parseAdditionalHeaders(additional_headers);
        if (parsedHeaders) {
            Object.keys(parsedHeaders).forEach(key => {
                headers[key] = String(parsedHeaders[key]);
            });
        }
    }
    // This endpoint allows lightweight status check even if session isn't in DB yet
    let response = axios.get(`${baseUrl}/api/v1/innlive/public/session/${sessionId}`);
    return response;
}

export async function fetchFlowPublicStatus(baseUrl: string, flowId: string, api_key?: string, additional_headers?: { [key: string]: string } | string) {
    let headers: { [key: string]: string } = { "Content-Type": "application/json" }
    if (api_key) {
        headers["x-api-key"] = api_key;
    }
    if (additional_headers) {
        const parsedHeaders = parseAdditionalHeaders(additional_headers);
        if (parsedHeaders) {
            Object.keys(parsedHeaders).forEach(key => {
                headers[key] = String(parsedHeaders[key]);
            });
        }
    }
    let response = axios.get(`${baseUrl}/api/v1/flows/public_status/${flowId}`, { headers });
    return response;
}